var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5951 14.8359H13.4076C13.2176 14.8359 13.0355 14.9114 12.9012 15.0457C12.7669 15.18 12.6914 15.3621 12.6914 15.5521V27.7266C12.6914 28.1064 12.8423 28.4707 13.1109 28.7393C13.3795 29.008 13.7438 29.1589 14.1237 29.1589H29.8789C30.2588 29.1589 30.6231 29.008 30.8917 28.7393C31.1603 28.4707 31.3112 28.1064 31.3112 27.7266V15.5521C31.3112 15.3621 31.2357 15.18 31.1014 15.0457C30.9671 14.9114 30.785 14.8359 30.5951 14.8359ZM28.7537 16.2682L22.0013 22.4584L15.2489 16.2682H28.7537ZM29.8789 27.7266H14.1237V17.1804L21.517 23.9578C21.6491 24.0791 21.822 24.1464 22.0013 24.1464C22.1807 24.1464 22.3535 24.0791 22.4856 23.9578L29.8789 17.1804V27.7266Z",
    fill: "currentColor",
    fillOpacity: 0.96,
    stroke: "currentColor",
    strokeWidth: 0.183333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c42ed366c12a46cf11a625ca2b16bf12.svg";
export { ForwardRef as ReactComponent };